// https://getbootstrap.com/docs/5.0/components/alerts/

import { is } from '@common/is/is'

import type { TState, IBaseProps, IChildrenProps } from '../definitions'

interface IProps extends IBaseProps, IChildrenProps {
  readonly type: TState
}

/**
 * Egy BS Alert komponens factory-ja.
 * @param props - Props {@link IProps}.
 */
export default function Alert (props: IProps): HTMLElement {
  const { children, className: cn, type, ...rest } = props

  const classList: string[] = [
    'alert',
    `alert-${ type }`
  ]

  if (cn) {
    if (is.string(cn)) {
      classList.push(cn)
    }
    else {
      classList.push(...cn)
    }
  }

  const alert: HTMLElement = (
    <div
      className={ classList }
      role="alert"
      { ...rest }
    >
      { children }
    </div>
  )

  return alert
}
